import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { IProductData } from 'interfaces/IProductData';
import React from 'react';
import { cartService } from 'services/CartService';
import Translate from 'components/Translate';
import { enPaymentType } from 'enums/enPaymentType';
import FieldText from 'components/Field/Text';
import { showAlert } from 'shared/services/dialog';

interface IState extends IStateBase {
  cart: IProductData;
  price: number;
}

export default class OpenValue extends BaseComponent<IState, any> {
  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
  }

  setValue = (value: string) => {
    const price = Number(value.replace(/\D+/gi, '')) / 100;

    this.setState({ price });
  };

  onBlur = () => {
    if (!this.state.price || this.state.price < 0) {
      return;
    }

    cartService
      .setOpenValueCart(this.state.price)
      .catch(() => {
        return showAlert('Ocorreu um erro ao aplicar o valor no carrinho').map(() => false);
      })
      .subscribe();
  };

  render() {
    if (!this.state) {
      return '';
    }
    const { cart, price } = this.state;

    return (
      <div>
        {cart.config.paymentType == enPaymentType.DONATION && (
          <div className="donation-input">
            <FieldText
              id={'donation-value'}
              label={<Translate term="Valor" />}
              validation="required|min:5"
              value={price ?? cart.openValuePrice}
              mask={'money'}
              onBlur={this.onBlur}
              inputProps={{
                pattern: '[0-9]*',
                inputMode: 'numeric',
                className: 'theme-input'
              }}
              InputLabelProps={{
                className: 'theme-label'
              }}
              onChange={this.setValue}
            />
          </div>
        )}
      </div>
    );
  }
}
